import template from './vouchers.html';
import controller from './vouchers.controller';

let vouchersComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default vouchersComponent;
